<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div
      class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold"
      v-html="title"
    />
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row">
        <div class="col-12 col-md-4 d-flex flex-column">
          <span class="d-block pb-2">StoPrefa Coll SB</span>
          <div>
            <button
              type="button"
              v-for="(item, index) in items.scsb"
              :key="index"
              :class="[
                'btn btn-sm btn-outline-filter',
                filterUiState('fill', item.value),
              ]"
              v-on:click="selectValue(item.value)"
            >
              {{ item.title }}
            </button>
          </div>
        </div>
        <div class="col-12 col-md-4 d-flex flex-column">
          <span class="d-block pb-2">Ungebun&shy;dener Splitt</span>
          <div>
            <button
              type="button"
              v-for="(item, index) in items.us"
              :key="index"
              v-bind:item="item"
              :class="[
                'btn btn-sm btn-outline-filter',
                filterUiState('fill', item.value),
              ]"
              v-on:click="selectValue(item.value)"
            >
              {{ item.title }}
            </button>
          </div>
        </div>
        <div class="col-12 col-md-4 d-flex flex-column">
          <span class="d-block pb-2">StoPrefa Coll SB 100</span>
          <div>
            <button
              type="button"
              v-for="(item, index) in items.scsb100"
              :key="index"
              v-bind:item="item"
              :class="[
                'btn btn-sm btn-outline-filter',
                filterUiState('fill', item.value),
              ]"
              v-on:click="selectValue(item.value)"
            >
              {{ item.title }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { trackCallstack } from "../../../helper/tracker";

export default {
  name: "StoCscFilterSectionFill",
  props: {
    addContainerClasses: String,
  },
  data: function () {
    return {
      title: "Schüttung",
      items: {
        scsb: [
          { title: "≥ 18 mm", value: "scsb-18" },
          { title: "≥ 30 mm", value: "scsb-30" },
          { title: "≥ 40 mm", value: "scsb-40" },
          { title: "≥ 50 mm", value: "scsb-50" },
          { title: "≥ 60 mm", value: "scsb-60" },
          { title: "≥ 65 mm", value: "scsb-65" },
          { title: "≥ 80 mm", value: "scsb-80" },
          { title: "≥ 120 mm", value: "scsb-120" },
          { title: "ohne", value: null },
        ],
        us: [{ title: "≥ 65 mm", value: "us-65" }],
        scsb100: [
          { title: "≥ 65 mm", value: "scsb100-65" },
          { title: "≥ 105 mm", value: "scsb100-105" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      filterUiState: "filter/uiState",
      filterState: "filter/state",
    }),
  },
  methods: {
    selectValue: function (value) {
      let title = "";
      let result = this.items.scsb.filter((item) => item.value === value);
      if (result.length <= 0)
        result = this.items.us.filter((item) => item.value === value);
      if (result.length <= 0)
        result = this.items.scsb100.filter((item) => item.value === value);
      if (result.length > 0) title = result[0].title;

      const uiState = this.filterUiState("fill", value);

      let category = "";

      if (this.items.scsb.some((item) => item.value === value)) {
        category = "StoPrefa Coll SB";
      } else if (this.items.us.some((item) => item.value === value)) {
        category = "Ungebundener Splitt";
      } else if (this.items.scsb100.some((item) => item.value === value)) {
        category = "StoPrefa Coll SB 100";
      }

      this.$gtm.trackEvent({
        event: "filter",
        category: category,
        action:
          uiState === "pending"
            ? "hinzufügen"
            : uiState === "active"
            ? "reaktivieren"
            : "aktivieren",
        label: title,
        value: value !== null ? Number(value.split("-")[1]) : value,
      });

      this.$store
        .dispatch("filter/setValue", {
          name: "fill",
          title: category + " " + title,
          value: value,
        })
        .then(() => trackCallstack(this.$gtm, this.filterState._callstack));
    },
  },
};
</script>
